/** Whether `value` is a non-null object, so its fields can be read as `unknown`. */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null
